import $ from "jquery";
import Swiper from "swiper/bundle";

const allStory = {};

allStory.storySlider = function () {
  const swiper = new Swiper("#popup-story .swiper", {
    slidesPerView: 1,
    pagination: {
      el: "#popup-story .swiper-pagination",
      clickable: true,
    },
  });
};

allStory.init = function () {
  this.storySlider();
};

allStory.init();
